<template>
  <div class="app-wrapper" :class="classObj">
    <div class="main-container">
      <navbar></navbar>
      <app-main ></app-main>
      <sidebar v-if="device=='desktop'" class="sidebar-container"></sidebar>
      <bottom-sidebar v-if="device=='mobile'"  class="bottom-sidebar-container" ></bottom-sidebar>

    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain, BottomSidebar } from './components'
import ResizeMixin from './mixin/ResizeHandler'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain,
    BottomSidebar
  },
  data() {
    return {
      isMobileSize:'desktop',
    }
  },
  // mounted() {
  //   this.$_resizeHandler();
  //   window.addEventListener('resize', this.$_resizeHandler);
  // },
  // beforeDestroy() {
  //   window.removeEventListener('resize', this.$_resizeHandler);
  // },
  // methods: {
  //   $_resizeHandler() {
  //     if (!document.hidden) {
  //       const isMobile = window.innerWidth < 768 || window.innerHeight / window.innerWidth > 1.5;
  //       let device = isMobile ? 'mobile' : 'desktop';
  //       this.isMobileSize = (device === 'mobile')
  //     }
  //   }
  // },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  margin-bottom:50px;
}
.bottom-sidebar-container {

  position: fixed;
  bottom: 0;
  width: 100%;
  height: 40px;
  background-color: #304156;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue